/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Loader } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import api from '../../api';
import progress from '../../images/icons/progress_ica.gif';
import WithRouter from '../Extensions/WithRouter';

class WebSecuritySystem extends Component {
  constructor(props) {
    super(props);
    //this.modalBody = '';
    const { t } = props;
    this.state = {
      isLoading: false,
      isLoadingSession: false,
      isLoadingMultipleSession: false,
      isLoadingRestrictOldPassword: false,
      isLoadingExpirationDay: false,
      sessionTimeout: t('system.list.2_hour'),
      resultMsg: '',
      sessionError: false,
      multipleSessionError: false,
      expirationDayError: false,
      restrictOldPasswordError: false,
      isUseMultipleSession: true,
      isRestrictOldPassword: false,
      expirationDay: t('system.list.off'),
      isUseComplexPassword: false,
      complexError: false,
      isLoadingcomplexPassword: false,
      isPageLoading: false,
      isCustomMode: false,
      afterDay: '0',
      scope: 'user_only',
      policyError: false,
      isLoadingPolicy: false,
    };
    this.setSessionTimeout = this.setSessionTimeout.bind(this);
    this.setMultipleSession = this.setMultipleSession.bind(this);
    this.setExpirationDay = this.setExpirationDay.bind(this);
    this.setRestrictOldPassword = this.setRestrictOldPassword.bind(this);
    this.setComplexPassword = this.setComplexPassword.bind(this);
    this.changeComplexPasswordToggle = this.changeComplexPasswordToggle.bind(this);
    this.changeRestrictOldPasswordToggle = this.changeRestrictOldPasswordToggle.bind(this);
    this.changeSessionValue = this.changeSessionValue.bind(this);
    this.changeExpriationDayValue = this.changeExpriationDayValue.bind(this);
    this.changeMultipleSessionToggle = this.changeMultipleSessionToggle.bind(this);
    this.updateSessionTimeout = this.updateSessionTimeout.bind(this);
    this.updateExpirationDay = this.updateExpirationDay.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    const { location } = this.props;

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getWebSecurity();
      this.setState({
        isPageLoading: false,
      });
    }

    if (prevProps.location && location) {
      const currentPath = location.pathname ? location.pathname : location;
      const prevPath = prevProps.location.pathname ? prevProps.location.pathname : prevProps.location;
      if (currentPath !== prevPath) {
        this.requiredAdmin();
      }
    }
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  getWebSecurity() {
    const { t } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api.getWebSecurity()
        .then((res) => {
          const data = res.response;
          let time;
          let days;
          if (data.session_timeout === 120) {
            time = t('system.list.2_hour');
          } else if (data.session_timeout === 15) {
            time = t('system.list.15_min');
          } else if (data.session_timeout === 1440) {
            time = t('system.list.24_hour');
          }

          if (data.password_change_cycle === 0) {
            days = t('system.list.off');
          } else if (data.password_change_cycle === 90) {
            days = t('system.list.90_days');
          } else if (data.password_change_cycle === 120) {
            days = t('system.list.120_days');
          } else if (data.password_change_cycle === 180) {
            days = t('system.list.180_days');
          }

          const inactiveAccount = data.inactive_account || {
            after_day: 0,
            scope: 'user_only',
          };

          const afterDay = inactiveAccount.after_day;
          const { scope } = inactiveAccount;

          const isCustomMode = afterDay !== 0 && afterDay !== 90;

          this.setState({
            isLoading: false,
            sessionTimeout: time,
            isUseMultipleSession: data.use_multiple_session,
            isRestrictOldPassword: data.restrict_old_password,
            expirationDay: days,
            isUseComplexPassword: data.use_complex_password,
            afterDay,
            scope,
            isCustomMode,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  setSessionTimeout() {
    const { t } = this.props;
    const { sessionTimeout } = this.state;
    let time;
    if (sessionTimeout === t('system.list.15_min')) {
      time = 15;
    } else if (sessionTimeout === t('system.list.2_hour')) {
      time = 120;
    } else if (sessionTimeout === t('system.list.24_hour')) {
      time = 1440;
    }
    this.updateSessionTimeout(time);
  }

  setExpirationDay() {
    const { t } = this.props;
    const { expirationDay } = this.state;
    let days;
    if (expirationDay === t('system.list.90_days')) {
      days = 90;
    } else if (expirationDay === t('system.list.120_days')) {
      days = 120;
    } else if (expirationDay === t('system.list.180_days')) {
      days = 180;
    } else {
      days = 0;
    }
    this.updateExpirationDay(days);
  }

  setMultipleSession() {
    const { t } = this.props;
    const { isUseMultipleSession } = this.state;
    const data = {
      use_multiple_session: isUseMultipleSession,
    };
    this.setState({
      isLoadingMultipleSession: true,
    }, () => {
      api
        .updateMultipleSession(data)
        .then(() => {
          this.setState({
            isLoadingMultipleSession: false,
            resultMsg: t('modal.button.ok'),
            multipleSessionError: true,
          }, () => {
            setTimeout(() => {
              this.setState({
                multipleSessionError: false,
              });
            }, 1000);
          });
        })
        .catch((err) => {
          this.setState({
            isLoadingMultipleSession: false,
            resultMsg: t('modal.error.failed'),
            multipleSessionError: true,
          }, () => {
            setTimeout(() => {
              this.setState({
                multipleSessionError: false,
              });
            }, 1000);
          });
          console.log(err);
        });
    });
  }

  setRestrictOldPassword() {
    const { t } = this.props;
    const { isRestrictOldPassword } = this.state;
    const data = {
      restrict_old_password: isRestrictOldPassword,
    };
    this.setState({
      isLoadingRestrictOldPassword: true,
    }, () => {
      api
        .updateRestrictOldPassword(data)
        .then(() => {
          this.setState({
            isLoadingRestrictOldPassword: false,
            resultMsg: t('modal.button.ok'),
            restrictOldPasswordError: true,
          }, () => {
            setTimeout(() => {
              this.setState({
                restrictOldPasswordError: false,
              });
            }, 1000);
          });
        })
        .catch((err) => {
          this.setState({
            isLoadingRestrictOldPassword: false,
            resultMsg: t('modal.error.failed'),
            restrictOldPasswordError: true,
          }, () => {
            setTimeout(() => {
              this.setState({
                restrictOldPasswordError: false,
              });
            }, 1000);
          });
          console.log(err);
        });
    });
  }

  setComplexPassword() {
    const { t } = this.props;
    const { isUseComplexPassword } = this.state;
    const data = {
      use_complex_password: isUseComplexPassword,
    };
    this.setState({
      isLoadingcomplexPassword: true,
    }, () => {
      api
        .updateComplexPassword(data)
        .then(() => {
          this.setState({
            isLoadingcomplexPassword: false,
            resultMsg: t('modal.button.ok'),
            complexError: true,
          }, () => {
            setTimeout(() => {
              this.setState({
                complexError: false,
              });
            }, 1000);
          });
        })
        .catch((err) => {
          this.setState({
            isLoadingcomplexPassword: false,
            resultMsg: t('modal.error.failed'),
            complexError: true,
          }, () => {
            setTimeout(() => {
              this.setState({
                complexError: false,
              });
            }, 1000);
          });
          console.log(err);
        });
    });
  }

  handlePolicyValidationError = (msg) => {
    this.setState(
      {
        resultMsg: msg,
        policyError: true,
      },
      () => {
        setTimeout(() => {
          this.setState({ policyError: false });
        }, 1000);
      }
    );
  };

  setIncativateAccount = () => {
    const { t } = this.props;
    const { afterDay, scope, isCustomMode } = this.state;

    if (isCustomMode) {
      if (afterDay === '' || afterDay === null || afterDay === undefined) {
        this.handlePolicyValidationError(
          t('system.message.auto_inactivate_after_empty')
        );
        return;
      }

      if (isNaN(afterDay) || !/^\d+$/.test(afterDay)) {
        this.handlePolicyValidationError(
          t('system.message.auto_inactivate_after_not_number')
        );
        return;
      }
    }

    const data = {
      after_day: Number(afterDay),
      scope,
    };
    this.setState(
      {
        isLoadingPolicy: true,
      },
      () => {
        api
          .updateIncativateAccount(data)
          .then(() => {
            this.setState(
              {
                isLoadingPolicy: false,
                resultMsg: t('modal.button.ok'),
                policyError: true,
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    policyError: false,
                  });
                }, 1000);
              }
            );
          })
          .catch((err) => {
            this.setState(
              {
                isLoadingPolicy: false,
                resultMsg: t('modal.error.failed'),
                policyError: true,
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    policyError: false,
                  });
                }, 1000);
              }
            );
            console.log(err);
          });
      }
    );
  };

  changeAfterDaySelect = (e) => {
    const { value } = e.target;
    if (value === 'custom') {
      this.setState({ isCustomMode: true, afterDay: '' });
    } else {
      this.setState({ isCustomMode: false, afterDay: parseInt(value, 10) });
    }
  };

  changeAfterDayInput = (e) => {
    const { value } = e.target;
    if (value === '' || (/^\d+$/.test(value) && parseInt(value, 10) >= 0)) {
      this.setState({ afterDay: value });
    }
  };

  changeScopeValue = (e) => {
    this.setState({
      scope: e.target.value,
    });
  };

  requiredAdmin() {
    const { state, navigate } = this.props;
    if (!state.user.isAdmin) {
      if (localStorage.getItem('main_page') === 'dashboard') {
        navigate('/main', { replace: true });
      } else if (localStorage.getItem('main_page') === 'results') {
        navigate('/results', { replace: true });
      } else {
        navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
      }
    }
  }

  changeSessionValue(e) {
    this.setState({
      sessionTimeout: e.target.value,
    });
  }

  changeExpriationDayValue(e) {
    this.setState({
      expirationDay: e.target.value,
    });
  }

  updateExpirationDay(value) {
    const { t } = this.props;
    const data = {
      password_change_cycle: value,
    };
    this.setState({
      isLoadingExpirationDay: true,
    }, () => {
      api
        .updatePasswordChangeCycle(data)
        .then(() => {
          this.setState({
            isLoadingExpirationDay: false,
            resultMsg: t('modal.button.ok'),
            expirationDayError: true,
          }, () => {
            setTimeout(() => {
              this.setState({
                expirationDayError: false,
              });
            }, 1000);
          });
        })
        .catch((err) => {
          this.setState({
            isLoadingExpirationDay: false,
            resultMsg: t('modal.error.failed'),
            expirationDayError: true,
          }, () => {
            setTimeout(() => {
              this.setState({
                expirationDayError: false,
              });
            }, 1000);
          });
          console.log(err);
        });
    });
  }

  updateSessionTimeout(value) {
    const { t } = this.props;
    const data = {
      session_timeout: value,
    };
    this.setState({
      isLoadingSession: true,
    }, () => {
      api
        .updateSessionTimeout(data)
        .then(() => {
          this.setState({
            isLoadingSession: false,
            resultMsg: t('modal.button.ok'),
            sessionError: true,
          }, () => {
            setTimeout(() => {
              this.setState({
                sessionError: false,
              });
            }, 1000);
          });
        })
        .catch((err) => {
          this.setState({
            isLoadingSession: false,
            resultMsg: t('modal.error.failed'),
            sessionError: true,
          }, () => {
            setTimeout(() => {
              this.setState({
                sessionError: false,
              });
            }, 1000);
          });
          console.log(err);
        });
    });
  }

  changeMultipleSessionToggle(e) {
    const { t } = this.props;
    const { isUseMultipleSession } = this.state;

    if (e.target.text === t('system.button.on')) {
      if (isUseMultipleSession) {
        return;
      }
      return this.setState({
        isUseMultipleSession: true,
      });
    }
    if (!isUseMultipleSession) {
      return;
    }
    return this.setState({
      isUseMultipleSession: false,
    });
  }

  changeRestrictOldPasswordToggle(e) {
    const { t } = this.props;
    const { isRestrictOldPassword } = this.state;

    if (e.target.text === t('system.button.on')) {
      if (isRestrictOldPassword) {
        return;
      }
      return this.setState({
        isRestrictOldPassword: true,
      });
    }
    if (!isRestrictOldPassword) {
      return;
    }
    return this.setState({
      isRestrictOldPassword: false,
    });
  }

  changeComplexPasswordToggle(e) {
    const { t } = this.props;
    const { isUseComplexPassword } = this.state;

    if (e.target.text === t('system.button.on')) {
      if (isUseComplexPassword) {
        return;
      }
      return this.setState({
        isUseComplexPassword: true,
      });
    }
    if (!isUseComplexPassword) {
      return;
    }
    return this.setState({
      isUseComplexPassword: false,
    });
  }

  render() {
    const {
      resultMsg,
      isLoading,
      sessionTimeout,
      isLoadingSession,
      isLoadingMultipleSession,
      isLoadingRestrictOldPassword,
      isLoadingExpirationDay,
      isUseMultipleSession,
      isRestrictOldPassword,
      expirationDay,
      isUseComplexPassword,
      isLoadingcomplexPassword,
      sessionError,
      multipleSessionError,
      isCustomMode,
      afterDay,
      scope,
      policyError,
      isLoadingPolicy,
      expirationDayError,
      restrictOldPasswordError,
      complexError,
    } = this.state;
    const { t, state } = this.props;

    const renderIfReady = (element) => {
      return (
        isLoading
          ? (
            <div style={{ height: '170px', paddingTop: '9%' }}>
              <Loader size="medium" active={isLoading} inline="centered" />
            </div>
          )
          : element
      );
    };

    return (
      <div className="content">
        <div className="setting_small_box web_security">
          <h2 className="page_title">{t('system.menu.web_security')}</h2>
          {renderIfReady(
            <>
              <div className="setting_contnets">
                <div className="setting_contnet_wrap">
                  <h3 className="setting_content_title">
                    {t('system.title.session_timeout')}
                  </h3>
                  <div className="setting_content">
                    <div className="setting_action_row">
                      <div className="input_group">
                        <div>
                          <select
                            value={sessionTimeout}
                            onChange={this.changeSessionValue}
                          >
                            <option>{t('system.list.15_min')}</option>
                            <option>{t('system.list.2_hour')}</option>
                            <option>{t('system.list.24_hour')}</option>
                          </select>
                        </div>
                      </div>
                      <div className="button_group">
                        {isLoadingSession ? (
                          <img
                            src={progress}
                            role="presentation"
                            className="loader"
                            alt=""
                          />
                        ) : (
                          <a
                            role="button"
                            tabIndex={0}
                            className="gray_button"
                            onClick={this.setSessionTimeout}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                this.setSessionTimeout();
                              }
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            {t('modal.button.save')}
                          </a>
                        )}
                      </div>
                      {resultMsg === t('modal.error.failed') ? (
                        <div
                          className={cx('error', {
                            show: sessionError,
                          })}
                          style={{ marginTop: 0 }}
                        >
                          {resultMsg}
                        </div>
                      ) : (
                        <div
                          className={cx('verified', {
                            show: sessionError,
                          })}
                          style={{ marginTop: 0 }}
                        >
                          {resultMsg}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {state.user.isAdmin && (
                <>
                  <div className="setting_contnets">
                    <div className="setting_contnet_wrap">
                      <h3 className="setting_content_title">
                        {t('system.title.use_multiple_session')}
                      </h3>
                      {!isUseMultipleSession && (
                        <div style={{ width: '100%', display: 'inline-block' }}>
                          <p className="text">
                            {t('system.message.warn_one_device')}
                          </p>
                        </div>
                      )}
                      <div className="setting_content">
                        <div className="setting_action_row">
                          <div className="input_group">
                            <div>
                              <div className="switch">
                                <a
                                  role="button"
                                  tabIndex={0}
                                  className={cx({
                                    checked: isUseMultipleSession,
                                  })}
                                  onClick={this.changeMultipleSessionToggle}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      e.preventDefault();
                                      this.changeMultipleSessionToggle();
                                    }
                                  }}
                                >
                                  {t('system.button.on')}
                                </a>

                                <a
                                  role="button"
                                  tabIndex={0}
                                  className={cx({
                                    checked: !isUseMultipleSession,
                                  })}
                                  onClick={this.changeMultipleSessionToggle}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      e.preventDefault();
                                      this.changeMultipleSessionToggle();
                                    }
                                  }}
                                >
                                  {t('system.list.off')}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="button_group">
                            {isLoadingMultipleSession ? (
                              <img
                                src={progress}
                                role="presentation"
                                className="loader"
                                alt=""
                              />
                            ) : (
                              <a
                                className="gray_button"
                                onClick={this.setMultipleSession}
                                style={{ cursor: 'pointer' }}
                              >
                                {t('modal.button.save')}
                              </a>
                            )}
                          </div>
                          {resultMsg === t('modal.error.failed') ? (
                            <div
                              className={cx('error', {
                                show: multipleSessionError,
                              })}
                            >
                              {resultMsg}
                            </div>
                          ) : (
                            <div
                              className={cx('verified', {
                                show: multipleSessionError,
                              })}
                            >
                              {resultMsg}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="setting_contnets">
                    <div className="setting_contnet_wrap">
                      <h3 className="setting_content_title">
                        {t('system.title.disallow_old_password')}
                      </h3>
                      {isRestrictOldPassword && (
                        <div style={{ width: '100%', display: 'inline-block' }}>
                          <p className="text">
                            {t('system.message.warn_five_password')}
                          </p>
                        </div>
                      )}
                      <div className="setting_content">
                        <div className="setting_action_row">
                          <div className="input_group">
                            <div>
                              <div className="switch">
                                <a
                                  className={cx({
                                    checked: isRestrictOldPassword,
                                  })}
                                  onClick={this.changeRestrictOldPasswordToggle}
                                >
                                  {t('system.button.on')}
                                </a>
                                <a
                                  className={cx({
                                    checked: !isRestrictOldPassword,
                                  })}
                                  onClick={this.changeRestrictOldPasswordToggle}
                                >
                                  {t('system.list.off')}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="button_group">
                            {isLoadingRestrictOldPassword ? (
                              <img
                                src={progress}
                                role="presentation"
                                className="loader"
                                alt=""
                              />
                            ) : (
                              <a
                                className="gray_button"
                                onClick={this.setRestrictOldPassword}
                                style={{ cursor: 'pointer' }}
                              >
                                {t('modal.button.save')}
                              </a>
                            )}
                          </div>
                          {resultMsg === 'Failed' ? (
                            <div
                              className={cx('error', {
                                show: restrictOldPasswordError,
                              })}
                            >
                              {resultMsg}
                            </div>
                          ) : (
                            <div
                              className={cx('verified', {
                                show: restrictOldPasswordError,
                              })}
                            >
                              {resultMsg}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="setting_contnets">
                    <div className="setting_contnet_wrap">
                      <h3 className="setting_content_title">
                        {t('system.title.password_policy')}
                      </h3>
                      {expirationDay !== t('system.list.off') && (
                        <div style={{ width: '100%', display: 'inline-block' }}>
                          <p className="text">
                            {t('system.message.password_auto_expire')}
                            {' '}
                            {expirationDay}
                          </p>
                        </div>
                      )}
                      <div className="setting_content">
                        <div className="setting_action_row">
                          <div className="input_group">
                            <div>
                              <select
                                value={expirationDay}
                                onChange={this.changeExpriationDayValue}
                              >
                                <option>{t('system.list.off')}</option>
                                <option>{t('system.list.90_days')}</option>
                                <option>{t('system.list.120_days')}</option>
                                <option>{t('system.list.180_days')}</option>
                              </select>
                            </div>
                          </div>
                          <div className="button_group">
                            {isLoadingExpirationDay ? (
                              <img
                                src={progress}
                                role="presentation"
                                className="loader"
                                alt=""
                              />
                            ) : (
                              <a
                                className="gray_button"
                                onClick={this.setExpirationDay}
                                style={{ cursor: 'pointer' }}
                              >
                                {t('modal.button.save')}
                              </a>
                            )}
                          </div>
                          {resultMsg === 'Failed' ? (
                            <div
                              className={cx('error', {
                                show: expirationDayError,
                              })}
                            >
                              {resultMsg}
                            </div>
                          ) : (
                            <div
                              className={cx('verified', {
                                show: expirationDayError,
                              })}
                            >
                              {resultMsg}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="setting_contnets">
                    <div className="setting_contnet_wrap">
                      <h3 className="setting_content_title">
                        {t('system.title.use_complex_password')}
                      </h3>
                      {isUseComplexPassword && (
                        <div style={{ width: '100%', display: 'inline-block' }}>
                          <div className="text">
                            <span
                              className="title"
                              style={{ fontSize: '12px', fontWeight: 'normal' }}
                            >
                              {t('system.title.password_match_policy')}
                            </span>
                            <ul className="ui bulleted list">
                              <li
                                style={{
                                  fontSize: '12px',
                                  fontWeight: 'normal',
                                }}
                              >
                                {t('system.message.not_match_account')}
                              </li>
                              <li
                                style={{
                                  fontSize: '12px',
                                  fontWeight: 'normal',
                                }}
                              >
                                {t('system.message.not_coantain_character')}
                              </li>
                              <li
                                style={{
                                  fontSize: '12px',
                                  fontWeight: 'normal',
                                }}
                              >
                                {t('system.message.not_keyboard_sequence')}
                              </li>
                            </ul>
                          </div>
                        </div>
                      )}
                      <div className="setting_content">
                        <div className="setting_action_row">
                          <div className="input_group">
                            <div className="switch">
                              <a
                                className={cx({
                                  checked: isUseComplexPassword,
                                })}
                                onClick={this.changeComplexPasswordToggle}
                              >
                                {t('system.button.on')}
                              </a>
                              <a
                                className={cx({
                                  checked: !isUseComplexPassword,
                                })}
                                onClick={this.changeComplexPasswordToggle}
                              >
                                {t('system.list.off')}
                              </a>
                            </div>
                          </div>
                          <div className="button_group">
                            {isLoadingcomplexPassword ? (
                              <img
                                src={progress}
                                role="presentation"
                                className="loader"
                                alt=""
                              />
                            ) : (
                              <a
                                className="gray_button"
                                onClick={this.setComplexPassword}
                                style={{ cursor: 'pointer' }}
                              >
                                {t('modal.button.save')}
                              </a>
                            )}
                          </div>
                          {resultMsg === 'Failed' ? (
                            <div
                              className={cx('error', {
                                show: complexError,
                              })}
                            >
                              {resultMsg}
                            </div>
                          ) : (
                            <div
                              className={cx('verified', {
                                show: complexError,
                              })}
                            >
                              {resultMsg}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="setting_contnets">
                    <div className="setting_contnet_wrap">
                      <h3 className="setting_content_title">
                        {t('system.title.inactive_account_policy')}
                      </h3>
                      <div className="setting_content">
                        <div className="setting_action_row">
                          <div
                            className="input_group"
                            style={{
                              display: 'flex',
                              gap: '15px',
                              width: '380px',
                            }}
                          >
                            <div
                              style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '6px',
                              }}
                            >
                              <label
                                htmlFor="auto-inactivate-select"
                                style={{
                                  fontSize: '12px',
                                  color: '#777',
                                  fontWeight: 'bold',
                                }}
                              >
                                {t('system.title.auto_inactivate_after')}
                              </label>
                              <select
                                id="auto-inactivate-select"
                                value={isCustomMode ? 'custom' : afterDay}
                                onChange={this.changeAfterDaySelect}
                                style={{ width: '100%' }}
                              >
                                <option value="0">
                                  {t('system.title.off')}
                                </option>
                                <option value="90">
                                  {t('system.title.90_days')}
                                </option>
                                <option value="custom">
                                  {t('system.title.custom')}
                                </option>
                              </select>
                            </div>
                            <div
                              style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '6px',
                              }}
                            >
                              <label
                                htmlFor="applies-to-roles-select"
                                style={{
                                  fontSize: '12px',
                                  color: '#777',
                                  fontWeight: 'bold',
                                }}
                              >
                                {t('system.title.applies_to_roles')}
                              </label>
                              <div>
                                <select
                                  id="applies-to-roles-select"
                                  value={scope}
                                  onChange={this.changeScopeValue}
                                  style={{ width: '100%' }}
                                >
                                  <option value="user_only">
                                    {t('system.title.user_only')}
                                  </option>
                                  <option value="user_and_admin">
                                    {t('system.title.user_and_admin')}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div
                            className="button_group"
                            style={{ marginTop: '16px', flexShrink: 0 }}
                          >
                            {isLoadingPolicy ? (
                              <img
                                src={progress}
                                role="presentation"
                                className="loader"
                                alt=""
                              />
                            ) : (
                              <a
                                className="gray_button"
                                onClick={this.setIncativateAccount}
                                style={{ cursor: 'pointer' }}
                              >
                                {t('modal.button.save')}
                              </a>
                            )}
                          </div>
                          {resultMsg === t('modal.error.failed') ? (
                            <div className="message_group">
                              <label
                                style={{
                                  display: 'block',
                                  height: '10px',
                                  marginBottom: '6px',
                                }}
                              >
                                &nbsp;
                              </label>
                              <div
                                className={cx('error', {
                                  show: policyError,
                                })}
                              >
                                {resultMsg}
                              </div>
                            </div>
                          ) : (
                            <div className="message_group">
                              <label
                                style={{
                                  display: 'block',
                                  height: '10px',
                                  marginBottom: '6px',
                                }}
                              >
                                &nbsp;
                              </label>
                              <div
                                className={cx('verified', {
                                  show: policyError,
                                })}
                              >
                                {resultMsg}
                              </div>
                            </div>
                          )}
                        </div>

                        {isCustomMode && (
                          <div
                            style={{
                              marginTop: '10px',
                              width: '467px',
                            }}
                          >
                            <input
                              type="number"
                              min="0"
                              value={afterDay === 0 ? '' : afterDay}
                              onChange={this.changeAfterDayInput}
                              placeholder={t('system.title.enter_days')}
                              style={{
                                width: '100%',
                                boxSizing: 'border-box',
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(WebSecuritySystem))));
